import * as React from 'react'
import {type BreadcrumbsProps} from '@frontrow/console/src/components/breadcrumbs'
import {Breadcrumbs} from '@frontrow/console/src/components/breadcrumbs'
import {H1} from '@frontrow/console/src/components/typography'

type Props = {
  title: string
  titleDataTest?: string
  breadcrumbsAttrs: BreadcrumbsProps | undefined | null
  children?: React.ReactNode
}

export function Page(props: Props): React.ReactElement {
  const {title, titleDataTest, breadcrumbsAttrs, children} = props

  const breadcrumbs =
    breadcrumbsAttrs !== null && breadcrumbsAttrs !== undefined ? (
      <Breadcrumbs {...breadcrumbsAttrs} />
    ) : null

  return (
    <div>
      <div className="mb-14">
        <H1 dataTest={titleDataTest}>{title}</H1>
        {breadcrumbs}
      </div>
      {children}
    </div>
  )
}
